module.exports = __webpack_public_path__ + "img/tuning_icon.c25e528c.svg";